import { Button, Paper, Grid, TextField, FormControl, InputLabel, Select, Chip } from "@material-ui/core";
import * as React from "react";
import { observable, toJS, action } from "mobx";
import { createStyles, withStyles, WithStyles } from "@material-ui/core/styles";
import { history } from "src/history.js";
import { authStore } from "src/modules/auth";
import { observer } from 'mobx-react';
import { config } from "src/config";
import { withRouter } from 'react-router';
import { AppPanel } from '../apps/AppPanel';
import { Responsive, WidthProvider } from 'react-grid-layout';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import { Widget } from '.';
import { DashboardStore } from '.';

const ResponsiveReactGridLayout = WidthProvider(Responsive);

const styles = createStyles({
    root: {
        padding: "2rem",
    },
    buttonDiv: {
        marginTop: "1rem",
        justifyContent: "center",
        display: "flex",
    },
    button: {
        height: "128px",
        width: "128px",
        marginRight: "24px",
        marginBottom: "24px",
        border: "1px solid #1f1d1d",
        color: "#efefef",
        borderRadius: "64px",
    }
});

@observer
class DevDashboard extends React.Component<any> {
    public state = { gridReady: false, startingWidth: 1200 };
    public widgetRef: React.RefObject<any>;
    public divRef: React.RefObject<any>;

    constructor(props: any) {
        super(props);
        this.widgetRef = React.createRef();
        this.divRef = React.createRef();
    };

    public componentDidMount = () => {
        if (this.divRef.current && !this.state.gridReady) {
            this.setState({ gridReady: true, startingWidth: this.divRef.current.offsetWidth })
        }
    }

    public componentDidUpdate = () => {
        if (this.divRef.current && !this.state.gridReady) {
            this.setState({ gridReady: true, startingWidth: this.divRef.current.offsetWidth })
        }
    }

    public generateGrid() {
        return DashboardStore.layout.map((widget_info: any) => {
            return (
                <div key={widget_info.id}>
                    <Widget widget_name={widget_info.WidgetName} />
                </div>
            )
        });
    };

    @action
    public layoutChange = (layout: any, layouts: any) => {
        if (!this.state.gridReady || !this.widgetRef.current) {
            return
        }
        let curBreakpoint = 'lg';
        const curWidth = this.widgetRef.current.state.width;

        if (curWidth < 1200 && curWidth >= 996) {
            curBreakpoint = 'md';
        }
        else if (curWidth < 996 && curWidth >= 768) {
            curBreakpoint = 'sm';
        }
        else if (curWidth < 768) {
            curBreakpoint = 'xs';
        }

        DashboardStore.saveDashboardLayout(authStore.currentUser.auth_id, layout, layouts, curBreakpoint);
    };

    public render() {
        const { classes } = this.props;

        if (!DashboardStore.layout || !DashboardStore.layouts || !DashboardStore.loaded) {
            return <div>loading</div>
        };

        return (
            <Grid container={true} className={classes.root}>
                <Grid item={true} xs={12}>
                    <AppPanel />
                </Grid>
                <Grid item={true} xs={12}>
                    <div ref={this.divRef}>
                        {this.state.gridReady ?
                            <ResponsiveReactGridLayout
                                className="layout"
                                layouts={DashboardStore.layouts}
                                cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}
                                rowHeight={30}
                                onLayoutChange={this.layoutChange}
                                // onBreakpointChange={this.breakpointChange}
                                ref={this.widgetRef}
                            >
                                {this.generateGrid()}
                            </ResponsiveReactGridLayout>
                            : null}

                    </div>
                </Grid>
                

            </Grid>
        )
    }
}

export default withStyles(styles, { withTheme: true })(
    withRouter(DevDashboard)
);


// WEBPACK FOOTER //
// ./src/modules/dashboard/DevDashboard.tsx